export default __webpack_public_path__ + "static/media/settings.inline.d2b3e355.svg";